import apiClient from './client';
import type { MailboxConfig, MailboxMessage, MailboxImportResult } from '../types';

/**
 * Get the current shared mailbox configuration.
 */
export async function fetchMailboxConfig(): Promise<MailboxConfig> {
  const { data } = await apiClient.get<MailboxConfig>('/mailbox/config');
  return data as MailboxConfig;
}

/**
 * Update the shared mailbox address.
 */
export async function updateMailboxConfig(
  config: MailboxConfig
): Promise<MailboxConfig> {
  const { data } = await apiClient.put<MailboxConfig>('/mailbox/config', config);
  return data as MailboxConfig;
}

/**
 * Fetch messages from the configured Exchange shared mailbox.
 */
export async function fetchMailboxMessages(
  params: { unread_only?: boolean; top?: number } = {}
): Promise<MailboxMessage[]> {
  const { data } = await apiClient.get<MailboxMessage[]>('/mailbox/messages', {
    params: {
      unread_only: params.unread_only ?? false,
      top: params.top ?? 50,
    },
  });
  return data as MailboxMessage[];
}

/**
 * Import a mailbox message as a new tender.
 * Uses the email subject as the tender title and the send date as created_at.
 */
export async function importMailboxMessage(
  messageId: string
): Promise<MailboxImportResult> {
  const { data } = await apiClient.post<MailboxImportResult>(
    `/mailbox/messages/${messageId}/import`
  );
  return data as MailboxImportResult;
}
